export default __webpack_public_path__ + "static/media/textile-southAsia.285ff3f1.png";